import { useNavigate } from "react-router-dom";
import { appRouterPaths } from "@/services/navigation";
import { useAppDispatch } from "@/services/store";
import { DEFAULT_NOTE_TYPES, type Note } from "@/services/api";
import { notesManagerActions } from "../model";

export const useNotesRedirect = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const redirect = ({ note }: { note: Note }) => {
    switch (note.noteType.name) {
      case DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT:
        navigate(appRouterPaths.commitments);
        break;
      case DEFAULT_NOTE_TYPES.DEFAULT_IDEA:
        navigate(appRouterPaths.ideas);
        break;
      default:
        navigate(appRouterPaths.notes);
        break;
    }
    dispatch(notesManagerActions.openNoteById({ noteId: note.id }));
  };

  return { redirect };
};
